import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import propagandaPlayer from "../../assets/propaganda-player.svg";

export function Round() {
  const { t } = useTranslation();
  const round = useSelector((state: RootState) => state.player.roundNumber);

  const roundBlock = (bgClass: string, titleKey: string) => (
    <div className="player-game-min flex w-full flex-col items-center overflow-y-auto bg-orange">
      <div className="flex w-full max-w-3xl flex-col items-center px-3 py-4 player-game-safe-y">
        <img
          alt="logo propaganda"
          className="z-30 mt-2 h-20 w-auto shrink object-contain xs:h-24 desktop:mt-8 desktop:h-44"
          src={propagandaPlayer}
        />
        <div
          className={`z-30 mt-4 h-[min(38vh,420px)] w-full min-h-[120px] shrink-0 rounded-sm bg-cover bg-center bg-no-repeat desktop:mt-10 desktop:h-[min(42vh,480px)] ${bgClass}`}
        />
        <h3 className="z-30 mt-4 w-[92%] max-w-3xl text-center font-Inter text-3xl font-thin text-darker-blue xs:text-4xl phone:mt-3 phone:text-4xl desktop:mt-12 desktop:text-9xl">
          {t(titleKey)}
        </h3>
      </div>
    </div>
  );

  return (
    <div className="player-game-min w-screen overflow-x-hidden bg-orange" id="round">
      {round === 1 && roundBlock("bg-round-one", "round.one")}
      {round === 2 && roundBlock("bg-round-two", "round.two")}
      {round === 3 && roundBlock("bg-laser-background", "round.three")}
    </div>
  );
}
